module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2313567"
    }
  }, [_c('b', [_vm._v("SOUTH-OF-THE-BORDER "), _c('br'), _vm._v(" CHICKEN SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d7e2314367"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c44_r1#d7e1508450",
      "id": "d14e6245"
    }
  }, [_vm._v(" (Pictured) ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2314867"
    }
  }, [_c('b', [_c('i', [_vm._v("We give this rich homemade soup a Latin accent with lime and cilantro, and serve it with chunks of buttery avocado and crisp tortilla chips.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2316167"
    }
  }, [_c('b', [_vm._v("Prep: 25 minutes Cook: 1 hour")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2316667"
    }
  }, [_vm._v("8 medium all-purpose potatoes (2½ pounds)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2317767"
    }
  }, [_vm._v("1 chicken (4 pounds), cut into 8 pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2318067"
    }
  }, [_vm._v("3 large stalks celery, each cut into thirds")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2318367"
    }
  }, [_vm._v("3 carrots, peeled and each cut into thirds")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2318767"
    }
  }, [_vm._v("2 medium onions, not peeled, each "), _c('br'), _vm._v(" cut into quarters")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2319367"
    }
  }, [_vm._v("10 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2319667"
    }
  }, [_vm._v("10 sprigs plus ¼ cup chopped fresh cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2320867"
    }
  }, [_vm._v("2 bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2321467"
    }
  }, [_vm._v("1 teaspoon whole black peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2321767"
    }
  }, [_vm._v("1 can (15¼ to 16 ounces) whole-kernel corn, drained")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2322967"
    }
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2323267"
    }
  }, [_vm._v("¼ cup fresh lime juice (about 2 large limes)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2324167"
    }
  }, [_vm._v("2 ripe medium avocados, cut into ½-inch pieces "), _c('br'), _vm._v(" tortilla chips "), _c('br'), _vm._v(" lime wedges")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2326267"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Peel 3 potatoes. In 8-quart Dutch oven, combine chicken, peeled potatoes, celery, carrots, onions, water, cilantro sprigs, bay leaves, and peppercorns; heat to boiling over high heat. Reduce heat; cover and simmer until chicken loses its pink color throughout and vegetables are tender, 35 to 45 minutes. Transfer chicken and potatoes to separate bowls.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2329067"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Strain broth through sieve into large bowl; discard vegetables. Skim and discard fat from broth; return broth to same clean Dutch oven. Mash cooked potatoes with 1 cup broth; stir mashed-potato mixture into broth in Dutch oven.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2331467"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Peel and chop remaining 5 potatoes. Add potatoes to broth; heat to boiling over high heat. Reduce heat; cover and simmer until potatoes are tender, about 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2333367"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Meanwhile, discard skin and bones from chicken; cut chicken into bite-size pieces. Stir chicken, corn, and salt into broth; heat through.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2335167"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" Just before serving, stir lime juice and chopped cilantro into soup. Serve with avocado, tortilla chips, and lime wedges. Makes about 16 cups or 8 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2336967"
    }
  }, [_vm._v("Each serving without garnishes: About 344 calories, 28g protein, 34g carbohydrate, 12g total fat (2g saturated), 76mg cholesterol, 772mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef30c44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c69_r1.vue
// module id = 273
// module chunks = 0